import VOTER_V3_ABI from './voterV3.json'

const VOTER_V3_ADDRESS = '0xCC5382FE1ecADBF18629C87b9C89a27B438889D4'

export { VOTER_V3_ADDRESS, VOTER_V3_ABI }
